export default __webpack_public_path__ + "static/media/main_banner1.bcd66162.png";